const WCSParams = require("../../configuration/ConfigWcs.json");
import {
  GetEnv,
  GetAuth,
  GetConfirmation,
  GetAjax,
  GetEnvValue,
  AuthRedirect,
} from "./Tools";
import { AJAX } from "./Fetch";
import * as utilCookieUtil from "../Utils/cookieUtil";

/*
 * 页面429接口处理
 */
export function getMarketingAvailability(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/marketing/availability`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/*
 * 公共的广告位 -- 文字 -- global
 */

export function getAdvertisingText(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktSimpleGroupController/simpleTextGroup`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*
 ** 公共的广告位 -- 文字 -- global
 */
export function getAdvertisingTextNew(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktHomePageController/recommendPcGroup`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*
 * 公共的广告位 -- 图片 -- global
 */
export function getAdvertisingImage(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktSimpleGroupController/simpleImageGroup`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*
 * 公共 -- 处理errcode对应的errormessage
 */
export function getErrorMessage(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/myaccount/message/errorMessage?errorCode=${params.code}`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
}
/*
 * limitpurchase - 清理限购
 */
export function getLimitPurchaseList(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/shopcart/shopcart/quick-list/1`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * RESEARCH
 */
export function poc(callback) {
  $.get(
    "/api/SOA/research/poc",
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

/*
 * 获取用户设备信息
 */
/**
 * RESEARCH
 */
export function getUaParser(params, callback) {
  $.get(
    "/api/SOA/myaccount/getUaParser",
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

/**
 * CRM
 */
/**
 * Ignore
 * @param params
 * @param callback
 */
export function getUserCardInfo(params, callback) {
  $.post(
    "/api/SOA/crm/getUserCardInfo",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
/**
 * Ignore
 * @param params
 * @param callback
 */
export function getUserInformation(params, callback) {
  $.post(
    "/api/SOA/crm/getUserInformation",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

/**
 * MARKETING
 */

export function getNavigationBrandGroup(callback) {
  AJAX(
    {
      url: `/v1/es/brandWall/queryAllBrands`,
      type: "POST",
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function setAdPositionCategory(value) {
  let match = [
    { id: "hot_rec", locationLabel: "PC:HOMEPAGE:POPULAR_CATALOG" },
    {
      id: "eb_exclusive",
      locationLabel: "PC:HOMEPAGE:OFFICIALEXCLUSIVE_CATALOG",
    },
    { id: "60001", locationLabel: "PC:HOMEPAGE:SKINCARE_CATALOG" },
    { id: "60002", locationLabel: "PC:HOMEPAGE:MAKEUP_CATALOG" },
    { id: "60003", locationLabel: "PC:HOMEPAGE:BATHBODYCARE_CATALOG" },
    { id: "60004", locationLabel: "PC:HOMEPAGE:TOOL_CATALOG" },
    { id: "60005", locationLabel: "PC:HOMEPAGE:MANSKINCARE_CATALOG" },
    { id: "60006", locationLabel: "PC:HOMEPAGE:HAIRCARE_CATALOG" },
    { id: "60007", locationLabel: "PC:HOMEPAGE:PERFUME_CATALOG" },
    { id: "60008", locationLabel: "PC:HOMEPAGE:FOOD_CATALOG" },
    // {'id': '60003', 'locationLabel': 'PC:HOMEPAGE:PERFUME_CATALOG'},
    // {'id': '60004', 'locationLabel': 'PC:HOMEPAGE:BATHBODYCARE_CATALOG'},
    // {'id': '60005', 'locationLabel': 'PC:HOMEPAGE:HAIRCARE_CATALOG'},
    // {'id': '60006', 'locationLabel': 'PC:HOMEPAGE:TOOL_CATALOG'},
    // {'id': '60007', 'locationLabel': 'PC:HOMEPAGE:MANSKINCARE_CATALOG'}
  ];
  for (let i in match) {
    if (value === match[i].id) {
      return {
        locationLabel: match[i].locationLabel,
      };
    }
  }
  return false;
}

export function getAdPositionCategory(value, callback) {
  let matchCategory = setAdPositionCategory(value);
  if (matchCategory) {
    AJAX(
      {
        type: "POST",
        url: `/v1/marketing/MktHomePageController/categoryTreeForEbAndHot`,
        data: { queryBody: { locationLabel: matchCategory.locationLabel } },
      },
      (json) => {
        if (json && json.results) {
          json.results._key = value;
        }
        callback(json);
      }
    );
  }
}

export function getSubCategory(value, callback) {
  let matchCategory = setAdPositionCategory(value);
  if (matchCategory) {
    AJAX(
      {
        type: "POST",
        url: `/v1/marketing/MktHomePageController/subCategoryGroup`,
        data: { queryBody: { locationLabel: matchCategory.locationLabel } },
      },
      (json) => {
        if (json && json.results) {
          json.results._key = value;
        }
        callback(json);
      }
    );
  }
}

export function getCheckoutDelete(callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktSimpleGroupController/simpleTextGroup`,
      data: {
        queryBody: {
          locationLabel: "PC:SHOPPING:CART:BULLETIN",
        },
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*购物车第二步广告位接口*/
export function getAdvertising(callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktSimpleGroupController/simpleTextGroup`,
      data: {
        queryBody: {
          locationLabel: "PC:CHECK_ORDER:MESSAGE",
        },
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getNavigationGroup(callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktHomePageController/categoryGroup`,
      data: { queryBody: { locationLabel: "PC:HOMEPAGE:CATEGORY" } },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**组赠 自选商品 */
export function getOptionalGift(data, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/getOptionalGift`,
      data: { queryBody: data },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/** 组赠 提交赠品 */

export function checkOptionalGift(data, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/checkOptionalGift`,
      data: { queryBody: data },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * MyAccount-profile
 */
//个人信息页上传图片
export function postUploadImage(params, callback) {
  $.ajax({
    method: "POST",
    processData: false,
    contentType: false,
    url: `https://${GetEnvValue(
      process.title,
      "api"
    )}/v1/pimBackend/image/uploadImage`,
    data: params,
    success: (json) => {
      console.log("Upload success");
      callback(GetConfirmation(json));
    },
    error: (error) => {
      console.log("Upload error", error);
    },
  });
}
export function uploadCustomHead(params, callback) {
  $.ajax({
    method: "POST",
    processData: false,
    contentType: false,
    headers: {
      UID: $.cookie("UID"),
      Token: $.cookie("Token"),
    },
    url: `https://${GetEnvValue(
      process.title,
      "api"
    )}/v1/myaccount/image/avatar/upload`,
    data: params,
    success: (json) => {
      console.log("Upload success");
      callback(GetConfirmation(json));
    },
    error: (error) => {
      console.log("Upload error", error);
    },
  });
}

export function getUserOptionalCard(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/card/multipleUserOptionalCard?mobile=${params.mobile}&email=${params.email}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
  // $.get('/api/SOA/myaccount/getUserOptionalCard', params, json => {
  //   callback( GetConfirmation( json ) );
  // }, 'json');
}

/*
 * myAccount-address
 */

//查询收货地址
export function getSingleAddress(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/addressManagement/address?addrId=${params}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//查询收货地址列表
export function getAddressList(callback) {
  AJAX(
    {
      url: `/v1/myaccount/addressManagement/addressListPC`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//设置默认地址
export function postDefaultAddress(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/addressManagement/defaultAddress`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//删除收货地址
export function postRemoveAddress(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/addressManagement/removeAddress`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//新建收获地址
export function postAddAddress(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/addressManagement/addAddress`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//编辑收获地址
export function putEditAddress(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/myaccount/addressManagement/editAddress`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/*
 * member-login
 */
//查询会员卡
export function postQueryCardsByMobile(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/user/queryCardsByMobile`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//查询会员卡v2
export function postLoginsms(params, callback) {
  // AJAX(
  //   {
  //     type: "POST",
  //     url: `/v1/usercenter/weblogin/sms`,
  //     headers: { channel: "PC" },
  //     data: params,
  //   },
  //   (json) => {
  //     callback(GetConfirmation(json));
  //   }
  // );

  $.post(
    "/api/SOA/myaccount/postMobilevalicodelogon",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

//绑定会员卡
export function postBindUserCard(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/user/bindUserCard`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//绑定会员卡v2
export function postBindUserCardV2(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v2/myaccount/user/bind/card`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//设置密码并登陆 --- 需要设置cookie
export function postSetPasswordAndLogin(params, callback) {
  $.post(
    "/api/SOA/myaccount/postSetPasswordAndLogin",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

//门店会员完善个人信息 -- 获取个人信息
export function getPersonalinfo(callback) {
  AJAX(
    {
      url: `/v1/myaccount/user/mobilevalicodelogon/personalinfo`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//门店会员完善个人信息 -- 完善个人信息
export function putPersonalinfo(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/myaccount/user/mobilevalicodelogon/personalinfo?birthday=${params.birthday}&name=${params.name}&gender=${params.gender}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function successfulPayment(params, callback) {
  AJAX(
    {
      url: `/v3/es/order/detail/pc/${params.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function changeOrderAddress(params, callback) {
  $.post(
    "/api/SOA/order/changeOrderAddress",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
export function updateOrderAddress(params, callback) {
  $.post(
    "/api/SOA/order/updateOrderAddress",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
export function addOrderAddress(params, callback) {
  $.post(
    "/api/SOA/order/addOrderAddress",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
//export function updateOrderAddress (params, callback) {
//$.post('/api/SOA/order/updateOrderAddress', params, json => {
//  callback(GetConfirmation(json));
//}, 'json');
//}

export function getOrderStatus(params, callback) {
  if (sessionStorage.guestToken) {
    const headers = { token: sessionStorage.guestToken };
    console.log('headers=====', headers);

    AJAX(
      {
        url: `/v1/order/orderInfo/orderstatu/${params.orderId}`,
        headers,
      },

      (json) => {
        callback && callback(GetConfirmation(json));
      }
    );
  } else {
    AJAX(
      {
        url: `/v1/order/orderInfo/orderstatu/${params.orderId}`,
      },

      (json) => {
        callback(GetConfirmation(json));
      }
    );
  }


}
export function getOrderInformation(params, callback) {
  AJAX(
    {
      url: `/v1/order/orderInfo/orderInformation/${params.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function createOrderUrl(params, callback) {
  const headers = { token: params.guestToken };
  delete params.guestToken;
  AJAX(
    {
      url: `/v1/order/pay/payInfo/${params.orderId}/${params.channel}/${params.type}?paymentCode=${params.paymentCode}`,
      headers
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * SHOPCART
 */

// 获取迷你购物车数据( ITEM接口 ) -- Jimmy
export function getMiniCart(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v3/shopcart/shopcart/miniShopcartInfo?channel=PC`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/* 单独获取数量的接口 */
export function getMiniCartNum(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/shopcart/shopcart/mini-shop-cart-count`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getGiftsByProm(params, callback) {
  AJAX(
    {
      url: `/v2/shopcart/shopcart/getGiftsByProms/${params.platform}?queryList=${params.queryList}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getUserAddressInfo(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/cneeinfo/queryCneeInfoList`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCheckOrderInformation(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v3/shopcart/shopcart/getShopcartStepTwo`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCheckOrderInformationOld(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/getShopcartStepTwo`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getSkuStandard(params, callback) {
  if (true || !params.login) {
    //游客模式切换规格
    AJAX(
      {
        type: "GET",
        url: `/v3/shopcart/shopcart/guest/model/queryAllSkuBySkuId?skuId=${params.skuId}&channel=PC&orderType=1`,
      },
      (json) => {
        json.errorMessage && alert(json.errorMessage);
        callback && callback(GetConfirmation(json));
      }
    );
  } else {
    AJAX(
      {
        url: `/v3/shopcart/shopcart/queryAllSkuBySkuId?skuId=${params.skuId}&channel=PC&orderType=1`,
      },
      (json) => {
        callback(GetConfirmation(json));
      }
    );
  }

}

// 游客模式:查询订单是否为游客订单
export function checkTouristOrderType(params, callback) {
    const headers = { token: params.guestToken };
    delete params.guestToken;
    AJAX(
        {
            type: "GET",
            headers,
            url: `/v3/es/order/detail/orderType/${params.orderId}`,
        },
        (json) => {
            json.errorMessage && alert(json.errorMessage);
            callback && callback(GetConfirmation(json.results));
        }
    );
}

export function getProvinceList(callback) {
  AJAX(
    {
      url: `/v1/shopcart/cneeinfo/initProvinceList`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//编辑
export function updateAddressExtend(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/updateCneeInfoUse`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//新建收货地址并使用
export function addCneeInfoAndSave(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/addCneeInfoAndSave`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function addOrderNote(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/shopcart/shopcart/addOrderNote`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postLive800Msg(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/product/consulation/userInfo`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function clearErrorSkuItem(params, callback) {
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC" },
      url: `/v1/shopcart/shopcart/removeFromCart`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function collectItemAll(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/favorite/addToFavorite`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function removeAllShopSku(params, callback) {
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC" },
      url: `/v1/shopcart/shopcart/removeFromCart`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function changeProductCheckedAll(params, callback) {
    // console.log(params,'params-------');
    let _params = params.value || [];
    let _query =_params.filter((item) => {
        if (item.skuId) {
            return item;
        }
    });
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/saveProdChkedStat`,
      // data: { queryBody: params.value },
      data: { queryBody: _query },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function changeSkuStandard(params, callback) {
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC" },
      url: `/v1/shopcart/shopcart/updateSku`,
      data: { queryBody: [params] },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function changeProductChecked(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/saveProdChkedStat`,
      data: { queryBody: [params] },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function appendProductQuantity(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/updateQuantity`,
      headers: { channel: "PC" },
      data: { queryBody: [params] },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 *购物车批量加购
 *
 * @export
 * @param {*} params
 * @param {*} callback
 */
export function postListAddToCart(params, callback) {
  console.log('par=======', params);
  AJAX(
    {
      type: "POST",
      url: `/v3/shopcart/shopcart/addToCart`,
      data: { queryBody: params.value },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function checkoutNoticeSubmit(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/reminder/saveArrivalReminderUserData`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function saveCheckoutProduct(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/favorite/addToFavorite`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//export function saveCheckoutProduct (params, callback) {
//$.post('/api/SOA/shopcart/saveCheckoutProduct', params, json => {
//  callback(GetConfirmation(json));
//}, 'json');
//}

export function removeCheckoutProduct(params, callback) {
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC" },
      url: `/v1/shopcart/shopcart/removeFromCart`,
      data: { queryBody: [params] },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}


export function getCartInfoDisplaying(params, callback) {

  AJAX(
    {
      type: "POST",
      url: `/v3/shopcart/shopcart/cartInfoDisplaying`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}



export function removeUserAddressInfo(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/cneeinfo/removeCneeInfo`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function setUserAddressDefault(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/cneeinfo/setDefaultCneeInfo`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function setReceivingAddress(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/shopcart/shopcart/addReceivingInformation`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function setDeliveryInfo(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/shopcart/shopcart/distributionInformation`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function createOrderId(params, rid, callback) {
  AJAX(
    {
      headers: { fengkongrid: rid },
      type: "POST",
      url: `/v3/shopcart/order/commitOrderExtend`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function setPayment(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/shopcart/payment/changePayment`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function setReceivingInformation(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/shopcart/shopcart/addReceivingInformation`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//export function setReceivingInformation (parameter, callback) {
//$.post('/api/SOA/shopcart/setReceivingInformation', parameter, json => {
//  callback(GetConfirmation(json));
//});
//}
export function getCheckoutTabMyFavorite(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/favorite/addToFavorite`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//export function getCheckoutTabMyFavorite (params, callback) {
//$.post('/api/SOA/shopcart/getCheckoutTabMyFavorite', params, json => {
//  callback(GetConfirmation(json));
//}, 'json');
//}
export function getCheckoutTabMyBrowserHistory(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/shopcart/shopcart/saveBrsProd`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//export function getCheckoutTabMyBrowserHistory (params, callback) {
//$.post('/api/SOA/shopcart/getCheckoutTabMyBrowserHistory', params, json => {
//  callback(GetConfirmation(json));
//}, 'json');
//}

export function setCheckoutGift(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/shopcart/shopcart/addGiftPackaging`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getAccountPhone(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/orderInfo/obtain/phone`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getPhoneMessage(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/orderInfo/verificationcode/${params.mobile}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function checkoutSilkPayInfo(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/pay/silkpayinfo`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getSilkCardList(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/orderInfo/silkpaycardlist/${params.phone}/${params.phoneCode}/${params.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * CATEGORY
 */
export function PopupRequest(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product/sku/optionalSkuSpec?productId=${params["productId"]}&skuId=${params["skuId"]}&channel=${params["channel"]}&isPromotion=${params["isPromotion"]}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function GetBrands(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/search-service/brand/keyword?categoryId=${params.categoryId}&filters=${params.filters}&hasInventory=${params.hasInventory}&keyWord=${params.keyWord}&searchBrandKeyWord=${params.searchBrandKeyWord}&hotWords=${params.hotWords}&searchType=${params.searchType}&funWords=${params.funWords}&attrWords=${params.attrWords}&categoryIds=${params.categoryIds}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * BRAND WALL
 *
 */

export function getBrandWallInfo(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/es/brandWall/queryAllBrands`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
  // $.post('/api/SOA/brand/getBrandWallInfo', params, json => {
  //   callback(GetConfirmation(json));
  // }, 'json');
}

/**
 * MISS
 */
export function getCheckoutData(userId, callback) {
  $.post("/api/SOA/getCheckoutData", { userId: userId }, (json) => {
    callback(GetConfirmation(json));
  });
}

/*
 *CATEGORYONELEVEL
 */

export function getCrumbs(params, callback) {
  // bodyStringify_Crumbs = JSON.stringify( body.catId )
  AJAX(
    {
      type: "POST",
      url: `/v1/es/groupCategory/getGroupCategory`,
      data: {
        queryBody: params.catId,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getContents(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/es/product/getTopCategory/soa_pim/${params.categroyid}`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getWeeklyspecialsContent(params, callback) {
  $.get("/api/SOA/change/getWeeklyspecialsContent", params, (json) => {
    callback(json);
  });
}

export function getContentContent(params, callback) {
  $.get("/api/SOA/change/getContentContent", params, (json) => {
    callback(json);
  });
}

export function getDownloadContent(params, callback) {
  $.get("/api/SOA/change/getDownloadContent", params, (json) => {
    callback(json);
  });
}

export function getContentTitle(params, callback) {
  $.get("/api/SOA/change/getContentTitle", params, (json) => {
    callback(json);
  });
}

/*register--begin*/
export function postUserMessageRegister(params, callback) {
  $.post(
    "/api/SOA/myaccount/postUserMessageRegister",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
/*register--end*/

/*Login--begin*/
export function postLogin(params, callback) {
  const { password, loginId } = params
  if (window) {
    params.password = window.btoa(password)
    params.loginId = window.btoa(loginId)
  }
  $.post(
    "/api/SOA/myaccount/postLogin",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
export function postLoginV2(params, callback) {
  const { password, loginId } = params
  if (window) {
    params.password = window.btoa(password)
    params.loginId = window.btoa(loginId)
  }
  $.post(
    "/api/SOA/myaccount/postLoginV2",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
/**
 *第三方登录
 *
 * @export
 * @param {*} params
 * @param {*} callback
 */
export function socialLogin(params, callback) {
  $.ajax({
    url: "/api/SOA/myaccount/socialLogin",
    async: false,
    type: "POST",
    data: params,
    success: (json) => {
      callback(GetConfirmation(json));
    },
  });
}
/*productDetail--end*/

/*orderDetail--begin*/
export function orderDetailInformation(params, callback) {
  AJAX(
    {
      url: `/v3/es/order/detail/pc/${params.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getLogisticInfoV3({ orderId }, callback) {
  AJAX(
    {
      url: `/v3/es/deliveryInfo/getDelivery/${orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*orderDetail--end*/

/*myAccount--begin*/
export function postSaveUserAccessChannel(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/user/saveUserAccessChannel?createTime=${params.date}&channel=${params.channel}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postDeleteMyOrder(params, callback) {
  const headers = { token: params.guestToken };
  delete params.guestToken;

  AJAX(
    {
      type: "POST",
      url: `/v1/order/orderInfo/cancelOrder`,
      headers,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function cancelProcessingOrder(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/orderInfo/cancelInProcessOrder`,
      headers: {
        channel: "PC",
      },
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountUserCardInfo(params, callback) {
  AJAX(
    {
      url: `/v1/portal/member/homepage/info`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCardBaseInfo(callback) {
  AJAX(
    {
      url: `/v1/portal/card/base/info`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCardPointsFlow(params, callback) {
  AJAX(
    {
      type: `GET`,
      url: `/v1/portal/card/points-flow?pageNo=${params.pageNo}`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountIntegralFlow(params, callback) {
  AJAX(
    {
      //url: `/v1/myaccount/user/validate/userGroup`
      url: `/v2/myaccount/user/view/control/points-history`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountFiveOrder(params, callback) {
  AJAX(
    {
      url: `/v2/myaccount/order/myOrder`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountAllOrder(params, callback) {
  let url = `/v3/es/orders/paging/${params.pageNo}/${params.pageSize}?orderTime=${params.orderTime}`
  if (params.orderStatus) {
    url += `&orderStatus=${params.orderStatus}`;
  }
  AJAX(
    {
      headers: {
        "sx-tenant-id": 1
      },
      /* url: `/v2/myaccount/order/orderList/${params.pageNo}/${params.pageSize}?orderTime=${params.orderTime}&orderStatus=${params.orderStatus}` */
      url: `/v3/es/orders/paging/${params.pageNo}/${params.pageSize}?orderTime=${params.orderTime}&orderStatus=${params.orderStatus}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountFiveHistory(params, callback) {
  /*$.get('/api/SOA/myaccount/getMyAccountFiveHistory', params, json => {
    callback(GetConfirmation(json));
  }, 'json');*/

  AJAX(
    {
      url: `/v1/myaccount/order/buyRecord`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountExpress(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/express/express/${params.orderId}/${params.itemNum}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMyAccountMyCoupon(params, callback) {
  let valid = params.valid;
  if (typeof valid !== "undefined") {
    valid = `?valid=${valid}`;
  } else {
    valid = `?valid=1`;
  }
  AJAX(
    {
      headers: { channel: "PC" },
      url: `/v2/myaccount/coupon/list/${params.pageNo}/${params.pageSize}${valid}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//我的优惠券页面获取优惠券V2
export function getCouponResults(params, callback) {
  let valid = params.valid;
  if (typeof valid !== "undefined") {
    valid = `?valid=${valid}`;
  } else {
    valid = "";
  }
  AJAX(
    {
      headers: { channel: "PC" },
      url: `/v2/myaccount/coupon/list/${params.pageNo}/${params.pageSize}${valid}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postAddToCart(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v3/shopcart/shopcart/addToCartForSingleProduct`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      if (json.jQueryStatus.status === 401) {
        //AuthRedirect(window.location);
      }
      callback(GetConfirmation(json));
    }
  );
}
export function getAddToCart(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/order/buyAgain/${params.orderId}?subOrderId=${params.subOrderId}`,
      headers: { channel: "PC" },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getOrderNumber(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/order/orderQuantity?orderTime=${params.orderTime}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getRestFirstCard(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/card/validateUserExchangedCard`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getUserAuthenticate(callback) {
  AJAX(
    {
      url: `/v1/myaccount/user/authenticate`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function putUserAuthenticate(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/myaccount/user/authenticate?mobile=${params.mobile}&smsCode=${params.smsCode}&smsModule=${params.smsModule}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/*myAccount--end*/

/*myAccountRestMyPassword--begin*/
export function postIsPhoneValid(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/user/loginIdUseableValid`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getPassword(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/password/password`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postPassword(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/password/password`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function putPassword(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/myaccount/password/password`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * @description spring37 改动
 * @todo 修改用户推荐头像
 */
export function updateDefultHead(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/myaccount/user/profile/default/avatar?defaultAvatarUrl=${params}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function putUserProfileV2(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/portal/member/profile/info`,
      headers: {
        channel: "PC",
      },
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getPrivateAllowModify(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/user/profile/allow-modify`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getPrivateInfo(params, callback) {
  if (params) {
    AJAX(
      {
        type: "GET",
        url: `/v1/portal/member/profile/info`,
        headers: {
          channel: "PC",
          convertMobile: params// convertMobile是否对手机号脱敏，默认为不脱敏，true脱敏，false不脱敏
        },
      },
      (json) => {
        callback(GetConfirmation(json));
      }
    );
  } else {
    AJAX(
      {
        type: "GET",
        url: `/v1/portal/member/profile/info`,
        headers: {
          channel: "PC"
        },
      },
      (json) => {
        callback(GetConfirmation(json));
      }
    );
  }

}
/* 客服专属 */
export function getUserProfile(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/portal/member/profile/info`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getMobileValid(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/user/mobileValid?mobile=${params.mobile}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*myAccountRestMyPassword--end*/

/*searchPassword--begin*/
export function getEmailSmsCode(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/email/email?email=${params.email}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getPhoneSmsCode(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/sms/smsCode/${params.mobile}/${params.module}/${params.valiCode}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getPhoneSmsCodeV2(params, callback) {
  AJAX(
    {
      url: `/v2/myaccount/password/mobile/valid/smsCode/${params.mobile}/${params.module}/${params.valiCode}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getPasswordUserCodeValidate(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/password/userCodeValidate?loginId=${params.loginId}&valiCode=${params.valiCode}&valiCodeToken=${params.valiCodeToken}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCheckEmailLink(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/email/checkEmailLink?email=${params.loginId}&active=${params.active}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postCreateUserValidate(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/myaccount/password/userValidate`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postCreateUserValidateV2(params, callback) {
  const _header = {
    channel: "PC",
  }
  if (params.NDFingerPrint) {
    _header["NDFingerPrint"] = params.NDFingerPrint;
    _header["loginType"] = params.loginType;
    _header["device"] = params.NDFingerPrint;
  }
  delete params.NDFingerPrint;;
    let _active = decodeURIComponent(params.active);
    params.active = _active.replace(/\s/g,'+');
  AJAX(
    {
      type: "POST",
      url: `/v2/myaccount/password/forgot`,
      headers: _header,
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*searchPassword--end*/

/*register--begin*/
export function getUserCardMessage(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/card/optionalCardInfo?loginId=${params.loginId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postCardBindOperation(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/card/cardBindOperation`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postPhoneMessage(params, callback) {
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC", Accept: "*/*" },
      url: `/v1/usercenter/verification/smsCode?rToken=${params.rtoken}&scene=${params.scene}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postEmailRegister(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/email/register?email=${params.email}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getEmailVerification(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/email/verification?code=${params.code}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getVildation(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/valicode/validate/${params.inputValiCode}/${params.valiCodeToken}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*register--end*/
export function postLoginOut(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/portal/logout`,
      headers: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*Login--begin*/
export function postVildation(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/valicode/code`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function postCaptcha 生成图形验证码
 */
export function postCaptcha(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/usercenter/verification/captcha?imageType=2&identification=${params.identification}`,
      headers: { channel: "PC", Accept: "*/*" },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * @Function checkCaptcha 校验图形验证码, 返回rtoken
 */
export function checkCaptcha(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/usercenter/verification/captcha?identification=${params.identification}&code=${params.code}&codeToken=${params.codeToken}`,
      headers: { channel: "PC" },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/*Login--end*/

/*productDetail--begin*/
export function getQaAndCommentsShow(params, callback) {
  AJAX(
    {
      url: `/v1/product/switch/comment?channel=${params.channel}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getAllShowPro(params, callback) {
  AJAX(
    {
      url: `/v1/pimBackend/product/getAllShowPro?productId=${params.productId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getProdAllColor(parameter, callback) {
  AJAX(
    {
      url: `/v1/product/sku/allColorProperty/${parameter}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getColorNestedInfo(params, callback) {
  let { productId, colorValue, colorType } = params;
  if (productId) {
    AJAX(
      {
        url: `/v1/product/sku/concreteColor?productId=${productId}&colorValue=${colorValue}&colorMaterial=${colorType}`,
      },
      (json) => {
        callback(GetConfirmation(json));
      }
    );
  }
}
export function getOptionalSkuSpec(params, callback) {
  AJAX(
    {
      url: `/v1/product/sku/optionalSkuSpec?productId=${params.productId}&skuId=${params.skuId}&channel=PC&isPromotion=${params.isPromotion}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getProductImage(params, callback) {
  AJAX(
    {
      url: `/v1/product/sku/skuImagePath?skuId=${params.skuId}&productId=${params.productId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getBreadcrumb(params, callback) {
  AJAX(
    {
      url: `/v1/product/sku/breadcrumb?productId=${params.productId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getQAList(params, callback) {
  AJAX(
    {
      url: `/v1/product/consulation/consulationListForPC?productId=${params.productId}&pageNo=${params.pageNo}&pageSize=${params.pageSize}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCommentsList(params, callback) {
  AJAX(
    {
      url: `/v1/product/comment/commentListForPC?productId=${params.productId}&pageNo=${params.pageNo}&pageSize=${params.pageSize}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getValidateUserBuyOneYear(params, callback) {
  AJAX(
    {
      url: `/v1/product/comment/validateUserBuyOneYear`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCommentYes(params, callback) {
  AJAX(
    {
      url: `/v3/product/comment/commodity-details/validate-send-comment/${params.productId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getCollocation(params, callback) {
  AJAX(
    {
      url: `/v1/product/product/recommend/${params.productId}/${params.pageNo}/${params.pageSize}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function productPromotionsGifts(params, callback) {
  AJAX(
    {
      url: `/v1/product/sku/gifts?promotionIds=${params.promotionId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
  // $.get('/api/SOA/product/productPromotionsGifts', params, json => {
  //   callback(GetConfirmation(json));
  // }, 'json');
}

export function getSKUPromotionInfo(params, callback) {
  let skuPromotionInfo_url;
  if (params.skuId) {
    skuPromotionInfo_url = `/v1/product/sku/skuPromotionInfo?channel=PC&productId=${params.productId}&skuId=${params.skuId}`;
  } else {
    skuPromotionInfo_url = `/v1/product/sku/skuPromotionInfo?channel=PC&productId=${params.productId}`;
  }
  AJAX(
    {
      url: skuPromotionInfo_url,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function postQA(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/product/consulation/sendConsulation`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function sendComment(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v3/product/comment/sendComment`,
      headers: {
        channel: "PC",
      },
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postSkuDetailInfo(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/product/product/skuDetailInfo`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function ProductSkuCustomMade(params, callback) {
  AJAX(
    {
      url: `/v1/product/sku/custom-made/${params}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function sendVbGifts(params, callback) {
  let VbparmsUrl;
  if (params.skuId) {
    VbparmsUrl = `/v2/product/sku/promotion/PC/${params.productId}?skuId=${params.skuId}`;
  } else {
    VbparmsUrl = `/v2/product/sku/promotion/PC/${params.productId}`;
  }
  AJAX(
    {
      url: VbparmsUrl,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function getProductPosts(params, callback) {
  AJAX(
    {
      url: `/v1/community/posts/product/pc/${params.productId}/?pagingState=${params.pagingState}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getProductNinePostDetail(params, callback) {
  AJAX(
    {
      url: `/v1/community/post/detail/nine-block/${params.openId}/${params.postId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getProductImagePostDetail(params, callback) {
  AJAX(
    {
      url: `/v1/community/post/detail/graphic-text/${params.authorOpenId}/${params.postId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/*productDetail--end*/

/*MyAccountRestMyCard--begin*/
export function getExchangeOptionalCard(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/card/exchangeOptionalCard?email=${params.email}&mobile=${params.mobile}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postCardBindingOperation(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/card/exchangeUserCard`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*MyAccountRestMyCard--end*/

/*index--begin*/
export function getUserBindCardNo(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/user/userBindCardNo`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*index--end*/

/* integralFlow---begin */
export function getPointsHistoryFlow(params, callback) {
  AJAX(
    {
      url: `/v1/myaccount/card/points/historyflow/${params.pageNo}/${params.pageSize}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/* integralFlow---end */

/* reservation---begin */
export function postIndexReservation(params, callback) {
  $.get(
    "/api/SOA/Util/postIndexReservation",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}
/* reservation---end */
/*
 * 默认产品
 */
export function getProductsByIds(value, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v2/product/product/history-browsing/products?channel=PC`,
      abort: `/v2/product/product/history-browsing/products?channel=PC`,
      data: { queryBody: value },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*
 * 模糊搜索
 */
export function getSearchResultsV2(value, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/search-service/product/suggest?keyWord=${value}`,
      abort: `/v1/search-service/product/suggest`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/*
 * UTIL获取html内容的接口
 */
export function postSkuHtml(params, callback) {
  $.get(
    "/api/SOA/Util/getProductDetails",
    params,
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

export function getCampaignContent(params, callback) {
  $.get("/api/SOA/Util/getCampaignContent", params, (json) => {
    callback(json);
  });
}

export function getCampaignTitle(params, callback) {
  $.get("/api/SOA/Util/getCampaignTitle", params, (json) => {
    callback(json);
  });
}

/*我的列表页广告位接口*/
export function MyAccountAdvertisingText(callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/marketing/MktSimpleGroupController/simpleTextGroup`,
      data: {
        queryBody: {
          locationLabel: "PC:ORDERLIST:TOP_TEXT_CAROUSEL",
        },
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 视频播放
 *@param {string} 视频ID
 */
export const getCCVideo = (id, callback) => {
  $.get(
    `https://m.sephora.cn/api/v2/SOA/proxy/getVideo?videoid=${id}`,
    (json) => {
      callback && callback(json);
    }
  );
};

/**
 * @function getPurchaseRecord
 */
export const getPurchaseRecord = (params, callback) => {
  AJAX(
    {
      type: "POST",
      url: `/v1/es/product/tryout`,
      data: {
        queryBody: {
          countOnly: false,
          filters: params.filters,
          hasInventory: params.hasInventory,
          pageNum: params.pageNum,
          pageSize: 25,
          sortField: params.sortField,
          sortMode: params.sortMode,
        },
      },
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};

//积分兑礼页面
export function getOrderHistory(callback) {
  $.post(
    "/api/SOA/Util/changeHistory",
    (json) => {
      callback(GetConfirmation(json));
    },
    "json"
  );
}

/**
 *@Function 获取退货理由列表
 */
export const getReturnReasonList = (callback) => {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/es/return/returnReasonSample`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};

// export const getReturnReasonList = (callback) => {
//   $.get(`http://rest.apizza.net/mock/486160cb9b27f54a1f84572d906e476f/returnReasonSample`, json => {
//       callback && callback(GetConfirmation(json));
//   });
// }

/**
 *@Function 获取退货详情
 */
export const returnDetailInformation = (parameter, callback) => {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/es/return/queryOrderReturn?returnId=${parameter.returnId}`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};

/**
 *@Function 获取可退货数量和价格
 */
export const getReturnItemPrice = (parameter, callback) => {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/es/return/returnItemUnit?orderId=${parameter.orderId}&returnSkuId=${parameter.returnSkuId}`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};

/**
 *@Function 获取退货详情by订单
 */
export const returnDetailByOrderId = (parameter, callback) => {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/es/return/queryOrderReturnDetail?orderId=${parameter.orderId}&returnSkuId=${parameter.returnSkuId}`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};
// export const returnDetailInformation = (parameter,callback) => {
//   $.get(`http://rest.apizza.net/mock/486160cb9b27f54a1f84572d906e476f/queryOrderReturn?returnId=${parameter.returnId}`, json => {
//       callback && callback(GetConfirmation(json));
//   });
// }

/**
 *@Function 获取退款单详情
 */
export const returnPayInformation = (parameter, callback) => {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/es/return/queryOrderRefund?returnId=${parameter.returnId}`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};
// export const returnPayInformation = (parameter,callback) => {
//   $.get(`http://rest.apizza.net/mock/486160cb9b27f54a1f84572d906e476f/queryOrderRefund?returnId=${parameter.returnId}`, json => {
//       callback && callback(GetConfirmation(json));
//   });
// }

/**
 *@Function 获取退货售后单列表
 */
export function getMyAccountAllOnlineReturnOrder(parameter, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/es/return/list/status`,
      data: parameter,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 上传图片接口
 */
export function uploadApplyImg(formData, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/return/applyImg/upload`,
      data: formData,
      processData: false,
      contentType: false,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 获取退货售后单数量
 */
export function getOnlineReturnOrderNumber(params, callback) {
  AJAX(
    {
      url: `/v1/order/es/return/list/quantity?showStatus=${params.showStatus}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 获取退货售后单可退换商品数量
 */
export function getReturnAvailableQty(params, callback) {
  AJAX(
    {
      url: `/v1/order/es/return/availableQty?orderId=${params.orderId}&returnSkuId=${params.returnSkuId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 提交退货申请
 */
export function onlineReturnApplication(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/return/onlineReturnApplication`,
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 修改退货申请
 */
export function editOnlineReturnApplication(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/order/return/onlineReturnApplication`,
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 退换货物流单填写
 */
export function onlineReturnlogisticsInfo(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/es/return/logisticsInfo`,
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/*
 * omni接口
 */
/* 线下订单列表 */
export const getOfflineOrderList = (params, callback) => {
  AJAX(
    {
      type: "GET",
      headers: {
        channel: "PC",
      },
      url: `/v1/omni/order/offlineOrder/list/${params.pageNo}?orderTime=${params.orderTime}`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
};

/**
 *@Function 查询我的消息列表
 */
export function myMsgList(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/omni/membermsg/mymsg/list/${params.pageNo}`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 查询我的消息未读数量
 */
export function msgUnreadCount(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/omni/membermsg/mymsg/unread/count`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 我的消息状态置已读
 */
export function readNewMsg(callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/omni/membermsg/mymsg/read`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 查询美力资讯列表
 */
export function InfoList(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/omni/membermsg/beauty/list/${params.pageNo}`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 查询美力资讯未读数量
 */
export function infoUnreadCount(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/omni/membermsg/beauty/unread/count`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *@Function 美力资讯状态置已读
 */
export function readNewInfo(callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/omni/membermsg/beauty/read`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 获得默认抬头
 */
export function getDefaultTitle(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/portal/invoicetitle/default`,
      headers: {
        uid: $.cookie("UID"),
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 新增抬头
 */
export function addInvoiceTitle(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/portal/invoicetitle`,
      data: params,
      headers: {
        uid: $.cookie("UID"),
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 编辑抬头
 */
export function editInvoiceTitle(params, callback) {
  AJAX(
    {
      type: "PUT",
      url: `/v1/portal/invoicetitle/${params.titleId}`,
      data: params,
      headers: {
        uid: $.cookie("UID"),
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 查询抬头列表
 */
export function getInvoiceTitleList(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/portal/invoicetitle`,
      headers: {
        uid: $.cookie("UID"),
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 根据订单获得发票信息
 */
export function getInvoiceList(orderId, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/invoice/list/${orderId}`,
      headers: {
        uid: $.cookie("UID"),
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 开具发票
 */
export function issueInvoice(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/order/invoice/${params.orderId}/channel?invoiceId=${params.invoiceId}&channel=PC`,
      headers: {
        uid: $.cookie("UID"),
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @Function 根据抬头id删除发票抬头
 */
export function deleteInvoiceTitle(titleId, callback) {
  AJAX(
    {
      type: "DELETE",
      url: `/v1/portal/invoicetitle?titleId=${titleId}`,
      headers: {
        uid: $.cookie("UID"),
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * 拆单的新逻辑 SPM-4451
 */

export function getOrderInfoV3({ orderId }, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v3/es/order/detail/pc/${orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
export function discountPrice(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/product/product/discount-price?channel=PC`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
 */
/**
 *记录用户同意隐私条款版本
 *
 * @export
 * @param {*} params
 * @param {*} callback
 */
export function postRecord(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/privacyClause/record`,
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 *
 *http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15931799
 * @export
 * @param {*} params
 * @param {*} callback
 */
export function getStandings(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product-extend/ranking/pc/${params.productId}?skuId=${params.skuId || ""
        }`,
      headers: {
        uid: $.cookie("UID"),
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15931802
 * @param {\} params
 * @param {*} callback
 */
export function getStandingList(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product-extend/ranking/${params.rankingId}/PC/${params.pageNum}`,
      headers: {
        uid: $.cookie("UID"),
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function postPhoneMessage_quondam(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v1/myaccount/sms/smsCode`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function booleanUserExist(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/usercenter/login/exist?rToken=${params.rtoken}&identification=${params.identification}`,
      headers: {
        channel: "PC",
      },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// 校验短信验证码
export function checkSmsCode(params, callback) {
  AJAX(
    {
      headers: {
        channel: "PC",
      },
      type: "GET",
      url: `/v1/usercenter/verification/smsCode?scene=${params.scene}&rToken=${params.rtoken}&telephone=${params.telephone}&smsCode=${params.smsCode}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//发送忘记密码邮件
export function sendEmail(params, callback) {
  AJAX(
    {
      headers: {
        channel: "PC",
      },
      type: "POST",
      url: `/v1/usercenter/verification/email?scene=FORGET&rToken=${params.rtoken}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function socBindMobile(params, callback) {
  const _header = {
    channel: "PC",
    uid: $.cookie("UID"),
  }
  if (params.NDFingerPrint) {
    _header["NDFingerPrint"] = params.NDFingerPrint;
  }

  delete params.NDFingerPrint;
  AJAX(
    {
      headers: _header,
      type: "POST",
      url: `/v1/usercenter/weblogin/bind`,
      data: params,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function putAuthenticate(params, callback) {
  AJAX(
    {
      headers: {
        channel: "PC",
        uid: $.cookie("UID"),
      },
      type: "PUT",
      url: `/v2/myaccount/user/authenticate?telephone=${params.telephone}&smsCode=${params.smsCode}&rToken=${params.rtoken}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//接口----用户手机号身份验证(检查手机号是否已是独立账号)
export function telephoneMember(params, callback) {
  AJAX(
    {
      headers: {
        channel: "PC",
        uid: $.cookie("UID"),
      },
      type: "POST",
      url: `/v2/myaccount/user/telephoneMember?telephone=${params.telephone}&smsCode=${params.smsCode}&rToken=${params.rToken}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
//接口----APP邮箱登录流程中强制绑定手机
export function bindPhone(params, callback) {
  AJAX(
    {
      headers: {
        channel: "PC",
        uid: $.cookie("UID"),
      },
      type: "POST",
      url: `/v2/myaccount/user/telephoneMember?telephone=${params.telephone}&smsCode=${params.smsCode}&rToken=${params.rtoken}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function emailBindPhone(params, callBack) {
  const _header = {
    channel: "PC",
    uid: $.cookie("UID"),
  }
  if (params.NDFingerPrint) {
    _header["loginType"] = "other";
    _header["NDFingerPrint"] = params.NDFingerPrint;
  }

  delete params.NDFingerPrint;
  AJAX(
    {
      headers: _header,
      type: "POST",
      url: `/v1/usercenter/weblogin/pwd/bind`,
      data:
        params,
    },
    (json) => {
      callBack(GetConfirmation(json));
    }
  );
}
/**
 * 购物车第一步:获取大促倒计时
 * @param {*} params 
 * @param {*} callback 
 */
export function getCountdown(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product/special-activity/countdown`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * 定金预售 付定金
 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15932066
 * @param {*} params 
 * @param {*} callback 
 */

export function commitOrderForImmediatelyBuy(params, rid, callback) {
  AJAX(
    {
      headers: { fengkongrid: rid },
      type: "POST",
      url: `/v2/shopcart/order/commitOrderForImmediatelyBuy`,
      data: { queryBody: params },
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
  * 获取套装信息(可包含多个主品)
 * @param {*} params 
 * @param {*} callback 
 */
export function getVbs(skucode, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v2/product/sku/vb/${skucode}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}



export function getBannerforTop(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/mpcms/common/banner/pc:home:popup?channel=pc`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * 品牌合作页面
 * PC品牌合作获取验证信息
 */

export function getValidation(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/portal/brand/validation`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * 品牌合作页面
 * PC品牌合作获取验证信息
 */
/**
 * 
 * @param {Object} data  
 *        validation 从getValidation 获取
 *          brandName	String	是	品牌名称 长度限制 40
            brandWebsite	String	是	品牌官网 长度限制 150
            contactName	String	是	联系人姓名  长度限制  20
            contactEmail	String	是	联系人邮箱  长度限制  50
            leaveMessage 留言信息      长度限制  300
 *        
 * @param {function} callback 
 */

export function PostCooperation(data, callback) {
  AJAX(
    {
      type: "POST",
      data,
      url: `/v1/portal/brand/cooperation?validation=${data.validation}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
/**
 * 立即购买-购物车核对订单页
 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=15926028
 */
export function stepTwoForImmediatelyBuy(data, callback) {
  AJAX(
    {
      headers: {
        "channel": "PC"
      },
      type: "POST",
      data: { queryBody: data },
      url: `/v2/shopcart/shopcart/stepTwoForImmediatelyBuy`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// MIUMIU 香水自选组合 Step 1
export function getMiuMiuStep1(spuId, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product/sku/groups/miumiu/detail/${spuId}?channel=PC`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// MIUMIU 香水自选组合 Step 2
export function getMiuMiuStep2(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product/sku/groups/miumiu/chose/${params.spuId}/${params.odorsku}?channel=PC`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// MIUMIU 香水自选组合 Step 3
export function getMiuMiuStep3(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/product/sku/groups/miumiu/comb?spuId=${params.spuId}&mainSkuId=${params.odorsku}&onePartSkuId=${params.lidSkuId}&twoPartSkuId=${params.bodySkuId}&channel=PC`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getOrderInformations(orderId, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/orderInfo/afterOrder/${orderId.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}


export function afterPaidUsingGET(orderId, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/orderInfo/afterPaid/${orderId.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function afterPayGET(orderId, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/order/orderInfo/afterPay/${orderId.orderId}`,
      // url: `/v1/es/order/afterPay/123`,
      // url: `/v1/es/order/afterPay/123`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function getRecommendProducts(data, callback) {
  AJAX(
    {
      headers: {
        "channel": "PC"
      },
      type: "POST",
      data,
      url: `/v1/product/product/settlement/recommend`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

// 默认是否使用私享卡/v1/portal/member/silkPay/is_default_use
export function isDefaultUse(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/portal/member/silkPay/is_default_use`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

// 获取丝享卡列表
export function getCardList(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "GET",
      url: `/v2/order/pay/silkpay/cardlist?orderId=${params.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

// 【丝享卡】查询丝享卡列表
export function getSilkpayCardListInfo(deviceID, callback) {
  AJAX(
    {
      headers: { device: deviceID },
      type: "GET",
      url: `/v1/portal/app/card/silkPay/cardList?pageNo=1&pageSize=20`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}


// 用户获取动态验证码（选择丝享卡支付时发送验证码功能）
export function sendMsg(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "GET",
      url: `/v2/order/pay/silkpay/sendMsg?orderId=${params.orderId}`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function cartSubtract(data, callback) {
  AJAX(
    {
      headers: {
        "channel": "PC"
      },
      type: "POST",
      data: data,
      url: `/v1/shopcart/shopcart/cartSku/qty/subtract`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// 丝享卡支付
export function silkPayment(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "POST",
      url: '/v2/order/pay/silkpay',
      data: params
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

//高风险用户带数美验证登录
/**
 *
 *
 * @export
 * @param {*} {requestId: "数美滑动验证Id" , secLoginToken:"登录时高风险用户返回token"}
 * @param {*} callback
 */
export function highRisk(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "POST",
      url: '/v1/usercenter/login/second/high-risk',
      data: params
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// 用户登录时选择允许/不允许多端登录
export function multiLogin(params, callback) {
  AJAX(
    {
      headers: { "channel": "PC", "multiLoginToken": params.multiLoginToken },
      // headers: { "channel": "PC", },
      type: "POST",
      url: '/v1/usercenter/login/multiLogin/' + params.permit,
    },
    (json) => {
      const { results } = json;

      if (results && results.sephoraToken) {
        const domain = process.env.NODE_ENV === 'production' ? ".sephora.cn" : '';
        utilCookieUtil.SetSingleCookie2({
          key: "Token",
          value: results.sephoraToken,
          domain: domain,
          path: "/",
        });
      }
      json.errorMessage && alert(json.errorMessage)
      callback && callback(GetConfirmation(json));
    }
  );
}
/**
 *
 *获取无库存商品弹窗信息接口
 * @export
 * @param {*} params
 * @param {*} callback
 */
export function getPopInfo(skuId, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "GET",
      url: `/v1/product/sku/no-inv/toast?skuId=${skuId}&channel=PC`,
    },
    (json) => {
      callback && callback(GetConfirmation(json));
    }
  );
}

export function getProductInventory(productIdList, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "POST",
      url: '/v1/es/product/has-inventory',
      data: productIdList
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// 换购活动商品列表页
export function getExchangeProductList(activityId, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "GET",
      url: `/v1/product/sku/exchange/list?activityId=${activityId}&channel=PC`,

    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
// 添加换购活动商品到购物车
/**
 *@link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=34933228
 *
 * @export
 * @param {*}  {
      "extraBuyActId": "108000001",
      "extraSkuDtos": [
        {
          "skuId": 1234567,
          "isAdd": true
        }
      ]
    }
 * @param {*} callback
 */
export function extraBuy(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "POST",
      url: '/v1/shopcart/shopcart/extra-buy/skus',
      data: params
    },
    (json) => {
      callback(GetConfirmation(json));

      json.errorMessage && alert(json.errorMessage)
      callback && callback(GetConfirmation(json));
    }
  );
}

export function offlineCouponList(params, callback) {
  if (params.valid == 1) {
    params.valid = 1;
  } else if (params.valid == 0) {
    params.valid = 2;
  } else if (params.valid == 2) {
    params.valid = 3;
  }
  AJAX(
    {
      headers: { channel: "PC" },
      type: "POST",
      url: '/v1/offlieLineExternal/coupon/list',
      data: params
    },
    (json) => {
      callback(GetConfirmation(json));
      json.errorMessage && alert(json.errorMessage)
      callback && callback(GetConfirmation(json));
    }
  );
}


/**
 * 隐私页面 (/v2/html/privacySetting)-WEB用户修改偏好开关状态
 *
 * @export
 * @param {*} params 个性化推送：personalizedpush 多端登录：multilogin
 * @param {*} callback
 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=34942963
 * 例子/v1/portal/web/preference/switch/personalizedpush?on=true
 */
export function updateSwitchInPrivacySetting(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "POST",
      url: `/v1/portal/web/preference/switch/${params.type}?on=${params.toogle}`
    },
    (json) => {
      json.errorMessage && alert(json.errorMessage)
      callback && callback(GetConfirmation(json));
    }
  );
}
/**
 * 隐私页面 (/v2/html/privacySetting)-WEB获取用户偏好开关状态
 *
 * @export
 * @param {*} params 个性化推送：personalizedpush 多端登录：multilogin
 * @param {*} callback
 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=34942961
 * 例子 /v1/portal/web/preference/switch/personalizedpush
 */
export function getSwitchInPrivacySetting(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "GET",
      url: `/v1/portal/web/preference/switch/${params}`,
    },
    (json) => {
      json.errorMessage && alert(json.errorMessage)
      callback && callback((json));
    }
  );
}

/**
 * 适用于个性化推送开关关闭-推荐页面商品配置
 *
 * @export
 * @param {*} params  
 * @param {*} callback
 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=23763807
 * 例子 /v1/product/product/find-recommend/10
 */
export function getFindRecommend(params, callback) {
  AJAX(
    {
      headers: { channel: "PC" },
      type: "GET",
      url: `/v2/product/product/find-recommend?pageSize=${params.pageSize || 20}`,
    },
    (json) => {
      json.errorMessage && alert(json.errorMessage)
      callback && callback(GetConfirmation(json));
    }
  );
}

/**
 * 适用于个性化推送开关关闭-获取折扣价
 *
 * @export
 * @param {*} params  
 * @param {*} callback
 * @link http://jiraconfluence.chinaeast2.cloudapp.chinacloudapi.cn:7223/pages/viewpage.action?pageId=23763807
 * 例子  {  "queryBody": ["565001_565009", "1"]}
export function getDiscountPrice(params, callback) {
  AJAX(
    {

      type: "POST",
      url: `/v1/product/product/discount-price?channel=PC`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      json.errorMessage && alert(json.errorMessage)
      callback && callback(GetConfirmation(json));
    }
  );
}
 */

/**
 *未登录购物车信息查询
 *
 * @export
 * @param {Integer} orderType 1--普通订单 2--定金订单c
 * @param {String}  channel	 	"PC"	渠道
 * @param {List}  shopcartSkus 
    skuId	商品id
    quantity	购物车中商品数量
    checked	选中状态：1：选中，0：未选中
 * @param {*} callback
 */
export function getGuestCartInfoDisplaying(params, callback) {
  AJAX(
    {
      type: "POST",
      url: `/v3/shopcart/shopcart/guest/model/cartInfoDisplaying`,
      data: {
        queryBody: params,
      },
    },
    (json) => {
      json.errorMessage && alert(json.errorMessage);
      callback && callback(GetConfirmation(json));
    }
  );
}

/**
 *未登录购物车切换商品规格
 *
 * @export
 * @param {Integer} orderType 1--普通订单 2--定金订单c
 * @param {String}  channel	 	"PC"	渠道
 * @param {List}  shopcartSkus 
    skuId	商品id
    quantity	购物车中商品数量
    checked	选中状态：1：选中，0：未选中
 * @param {*} callback
 */
export function getGuestQueryAllSkuBySkuId(params, callback) {
  AJAX(
    {
      type: "GET",
      url: `/v3/shopcart/shopcart/guest/model/queryAllSkuBySkuId?skuId=${params.skuId}&channel=PC&orderType=1`,
    },
    (json) => {
      json.errorMessage && alert(json.errorMessage);
      callback && callback(GetConfirmation(json));
    }
  );
}

export function postPhoneMessageV2(params, callback) {
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC", Accept: "*/*" },
      url: `/v2/usercenter/verification/smsCode`,
      data: params
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function postGuestLogin(params, callback) {
  const register = params.register;
  delete params.register;
  AJAX(
    {
      type: "POST",
      headers: { channel: "PC", Accept: "*/*" },
      url: `/v1/usercenter/weblogin/guest/${register}`,
      data: params
    },
    (json) => {

      callback(GetConfirmation(json));
    }
  );
}

export function getGuestShopcartStepTwo(params, callback) {
  const headers = { channel: "PC", Accept: "*/*", };// token: params.guestToken
  delete params.guestToken;
  AJAX(
    {
      type: "POST",
      headers,
      url: `/v3/shopcart/shopcart/guest/model/getShopcartStepTwo`,
      data: { queryBody: params, }
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

export function guestCommitOrderForImmediatelyBuy(params, callback) {
  const headers = { token: params.guestToken };
  delete params.guestToken;
  AJAX(
    {
      type: "POST",
      headers,
      url: `/v3/shopcart/shopcart/guest/model/commitOrderForImmediatelyBuy`,
      data: { queryBody: params, }
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function guestGetOrderById(params, callback) {
  const headers = { token: params.guestToken };
  delete params.guestToken;
//   callback({ "timeStamp": 1650002763864, "status": 0, "results": { "orderId": "100000017661505624", "orderStatus": "DPP", "orderOriginStatus": "M", "createTime": "2022-04-15 14:06:03", "calcCancelTime": 719, "deliveryTime": null, "deliverySummary": null, "recipientName": "123", "mobile": "13122083616", "province": "江苏", "city": "常州市", "area": "钟楼区", "address": "123", "zipcode": "11111", "deliveryInfo": "1", "payMethod": "在线支付", "shouldTotalPay": "360.01", "totalPayment": "360.01", "realProducts": [{ "skuId": "411560", "skuCode": "319483", "productId": "450585", "brandNameEN": "MAKEUPFOREVER", "productNameCN": "玫珂菲保湿补水妆前乳", "sapPrice": "360.00", "defaultImagePath": "https://sslstage4.sephorastatic.cn/products/3/1/9/4/8/3/1_n_new03504_", "quantity": 1, "skuSaleAttrDto": { "spec": 30.0, "specType": "volume", "custom": "," }, "offerPrice": "360.00", "orderId": "100000017661505624", "brandNameCN": "玫珂菲", "productNameEN": "MAKE UP FOR EVER HYDRATING PRIMER", "depositPrice": null, "returnStatus": null, "currentReturnStatus": null, "isSendComment": 0, "estimatedDeliveryTime": null, "skuType": 1, "exchangeDiscount": null, "buyAgain": true, "activityType": null, "itemId": null, "integral": null, "exchangeType": 0 }], "giftProducts": [], "comments": "", "giftComments": "", "wrapPart": null, "wrapPrice": null, "realProductsCount": 1, "giftProductsCount": 0, "totalAmount": "360.00", "discountAdjustment": "0.00", "couponAdjustment": "0.00", "shipping": "0.01", "orderType": "1", "switchIsOpen": "1", "cancelTime": null, "cancelReason": null, "payInfoDtos": [], "amountPaid": null, "amountPayable": null, "processOrderCancel": false, "isSplitOrder": "2", "paymentTime": null, "shippedTime": null, "signedTime": null, "rejectedTime": null, "estimatedDeliveryTime": null, "isDeliveryTimeOut": 0, "orderDepositList": [], "preSale": false, "mergeOrders": null, "mShouldPay": null, "priorityInDelivery": false, "priorityInDeliveryMsg": null, "editAddressTips": null, "sales": false, "accumulatePoints": null, "deliveryData": null, "deliveryCompany": null, "orderInvoiceSwitch": 3, "exchangeType": 0, "telephone": "123" }, "errorCode": null, "errorMessage": null }
//   )
  AJAX(
    {
      type: "POST",
      headers,
      url: `/v3/es/order/detail/tourist/${params.orderId} `,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}
export function editGuestAddressOrderById(params, callback) {
  const headers = { token: params.guestToken };
  delete params.guestToken;

  AJAX(
    {
      type: "POST",
      headers,
      url: `/v1/order/orderInfo/orderAddress/guest/${params.orderId} `,
      data: { queryBody: params }
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}

/**
 * @param callback
 */
export function getIsHomeGrey(callback) {
  AJAX(
    {
      type: "GET",
      url: `/v1/configuration/commonConfig`,
    },
    (json) => {
      callback(GetConfirmation(json));
    }
  );
}


/**
 * 首页-首单礼弹窗领券接口
 * @param {*} params
 * @param {*} callback
 */
export function getFirstOrder(callback) {
    AJAX(
        {
            headers: { channel: "APP" },
            type: "GET",
            url: `/v1/activity/coupon-event/firstOrder/popup`,
        },
        (json) => {
            json.errorMessage && alert(json.errorMessage)
            callback && callback(GetConfirmation(json));
        }
    );
}

export function getAd(params, callback) {
    AJAX(
        {
            type: "GET",
            url: `/v1/mpcms/common/banner/${params}?channel=mobile`,
        },
        (json) => {
            callback && callback(GetConfirmation(json));
        }
    );
}

export function getTongdunSwitch(callback) {
    AJAX(
        {
            type: 'GET',
            url: `/v1/usercenter/applogin/getTongdunSwitch`,
        },
        (json) => {
            callback(GetConfirmation(json))
        },
    )
}

export function getPcConfig(callback) {
    AJAX(
        {
            type: 'GET',
            url: `/v1/mpcms/common/pc/config`,
        },
        (json) => {
            callback(GetConfirmation(json))
        },
    )
}


// WEBPACK FOOTER //
// ./common/lib/BLL.js